 const submitForm = async ({ name, email, message, token }) => {
    try {
        const response = await fetch('https://kpiagjewi7apu6jf5od3wpftzy0ahlwh.lambda-url.us-east-1.on.aws', {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        },
        referrerPolicy: 'no-referrer',
        body: JSON.stringify({ name, email, message, token }),
    });

    // Log the raw response text
    const responseText = await response.text();
    console.log('Raw response:', responseText);

    // Try to parse the response as JSON
    const data = JSON.parse(responseText);

    if (response.status === 200) {
        return { success: true, message: 'Message sent successfully!' };
    } else {
        return { success: false, message: 'Failed to send message: ' + (data.error || 'Unknown error') };
    }
    } catch (error) {
        console.error('Error:', error);
        return { success: false, message: 'Error occurred when sending message: ' + error.message };
    }
};
  // Export the function using CommonJS syntax
  module.exports = { submitForm };